// //old code
// import React from 'react';
// import './BillPdf.css';
// import { Button } from '@mui/material';
// import WhatsAppIcon from '@mui/icons-material/WhatsApp';
// import { Link } from 'react-router-dom';
// import { useReactToPrint } from 'react-to-print';
// import { useRef } from 'react';
// import numWords from 'num-words';
// import { MessageData } from './MessageData';

// const BillPdf = ({ data, branchData, printRef, helpers }) => {
//   const { capitalizeWords } = helpers || {};
//   console.log(data, 'dtaBilllllllllll')
//   const printBillHandler = useReactToPrint({
//     content: () => printRef.current,
//     documentTitle: `${data?.invoice}`,
//   });

//   const whatsAppBillHandler = () => {
//     const url = MessageData(data, {}, branchData, data.feedbackUrl, data.billUrl);
//     window.open(url, '_blank');
//   };

//   const isMembershipBill = data?.billType === 'Membership';
//   const isPackageBill = data?.billType === 'Package';
//   const isWalletBill = data?.billType === 'Wallet';

//   const getAmountInWords = (amount) =>
//     `${capitalizeWords(numWords(Math.round(amount)))} Rupees Only`;

//   return (
//     <div className="print-section standard-bill-container">
//       <div ref={printRef} className="standard-bill-content">
//         <div className="standard-branch-name-container">
//           <h1 className="standard-branch-name">{data?.branchDetails?.branchName}</h1>
//         </div>

//         <div className="standard-bill-header">
//           <div className="standard-header-left">
//             <div className="standard-logo-container">
//               {data?.branchDetails?.logo && (
//                 <img src={data?.branchDetails?.logo?.url} alt="" className="standard-branch-logo" />
//               )}
//             </div>
//           </div>

//           <div className="standard-header-right">
//             <div className="standard-branch-details">
//               {data?.branchDetails?.address && (
//                 <p className="standard-detail-item">
//                   <span className="standard-detail-label">Address: </span>
//                   {data?.branchDetails?.address}
//                 </p>
//               )}
//               {data?.branchDetails?.branchPhone && (
//                 <p className="standard-detail-item">
//                   <span className="standard-detail-label">Phone: </span>
//                   {data?.branchDetails?.branchPhone}
//                 </p>
//               )}
//               {data?.branchDetails?.branchEmail && (
//                 <p className="standard-detail-item">
//                   <span className="standard-detail-label">Email: </span>
//                   {data?.branchDetails?.branchEmail}
//                 </p>
//               )}
//               {data?.taxes?.taxType === 'Exclusive' && data?.branchDetails?.gstNumber && (
//                 <p className="standard-detail-item">
//                   <span className="standard-detail-label">GSTIN: </span>
//                   {data?.branchDetails?.gstNumber}
//                 </p>
//               )}
//             </div>
//           </div>
//         </div>

//         <div className="standard-client-info-section">
//           <div className="standard-client-details">
//             <h3 className="standard-section-title">Bill To:</h3>
//             <p className="standard-client-name">{data?.clientName}</p>
//             <p className="standard-client-contact">Contact: {data?.clientNumber}</p>
//             {/* {data?.ownerId === '68273f689a2875f3d47ec010' && (
//               <>
//                 <p className="standard-client-contact">Address: {data?.clientAddress}</p>
//                 <p className="standard-client-contact">Gst Number: {data?.clientGstNumber}</p>
//               </>
//             )} */}
//             {data?.ownerId === '68273f689a2875f3d47ec010' && (
//               <>
//                 <p className="standard-client-contact"><strong>Address:</strong> {data?.clientAddress}</p>
//                 <p className="standard-client-contact"><strong>Gst Number:</strong> {data?.clientGstNumber}</p>
//                 <p className="standard-client-contact"><strong>Place of supply:</strong> {data?.clientPos}</p>
//               </>
//             )}
//           </div>
//           <div className="standard-invoice-details">
//             <h3 className="standard-section-title">Invoice Details</h3>
//             <p className="standard-invoice-number">Invoice #: {data?.invoice}</p>
//             <p className="standard-invoice-date">Date: {data?.formattedDate}</p>
//             <p className="standard-invoice-time">Time: {data?.formattedTime}</p>
//           </div>
//         </div>

//         {!isWalletBill && (
//           <div className="standard-items-table">
//             <table className="standard-items">
//               <thead>
//                 <tr>
//                   <th>#</th>
//                   <th>Description</th>
//                   {data?.products?.length > 0 ? <th>HSN Code</th> : ''}
//                   <th>Rate</th>
//                   <th>Qty</th>
//                   <th>Discount</th>
//                   {data?.taxes?.taxType === 'Exclusive' ? <th>Gst</th> : ''}
//                   <th>Amount</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {isMembershipBill &&
//                   data?.memberships?.map((item, index) => (
//                     <tr
//                       key={`membership-${index}`}
//                       className={`standard-service-row ${index % 2 === 0 ? 'standard-even-row' : 'standard-odd-row'
//                         }`}
//                     >
//                       <td>{index + 1}</td>
//                       <td>{item?.membershipName}</td>
//                       <td>₹{parseFloat(item?.price).toFixed(2)}</td>
//                       <td>{item?.quantity}</td>
//                       <td style={{ color: item.discount > 0 ? '#d32f2f' : 'inherit' }}>
//                         {item?.discount ? `${item.discount}${item.discountType}` : '0%'}
//                       </td>
//                       {data?.taxes?.taxType === 'Exclusive' && <td>{data.taxes.SGST}%</td>}
//                       <td>
//                         ₹
//                         {item?.amount ||
//                           item.price -
//                           (item.discountType === '%'
//                             ? (item.price * item.discount) / 100
//                             : item.discount) *
//                           item.quantity}
//                       </td>
//                     </tr>
//                   ))}

//                 {isPackageBill &&
//                   data?.packages?.map((item, index) => (
//                     <tr
//                       key={`package-${index}`}
//                       className={`standard-service-row ${index % 2 === 0 ? 'standard-even-row' : 'standard-odd-row'
//                         }`}
//                     >
//                       <td>{index + 1}</td>
//                       <td>{item?.packageName}</td>
//                       <td>₹{parseFloat(item?.price).toFixed(2)}</td>
//                       <td>{item?.quantity}</td>
//                       <td style={{ color: item.discount > 0 ? '#d32f2f' : 'inherit' }}>
//                         {item?.discount ? `${item.discount}${item.discountType}` : '0%'}
//                       </td>
//                       {data?.taxes?.taxType === 'Exclusive' && <td>{data.taxes.SGST}%</td>}
//                       <td>
//                         ₹
//                         {item?.amount ||
//                           item.price -
//                           (item.discountType === '%'
//                             ? (item.price * item.discount) / 100
//                             : item.discount) *
//                           item.quantity}
//                       </td>
//                     </tr>
//                   ))}

//                 {!isMembershipBill &&
//                   !isPackageBill &&
//                   data?.services?.map((item, index) => (
//                     <tr
//                       key={`service-${index}`}
//                       className={`standard-service-row ${index % 2 === 0 ? 'standard-even-row' : 'standard-odd-row'
//                         }`}
//                       style={item.discount === 100 ? { backgroundColor: '#bfc7f1' } : {}}
//                     >
//                       <td>{index + 1}</td>
//                       <td>
//                         {item?.serviceName}
//                         {item?.serviceProviderName && (
//                           <div className="standard-service-provider">
//                             By: {item?.serviceProviderName}
//                           </div>
//                         )}
//                       </td>
//                       {item?.hsnCode ? (
//                         <td>{item.hsnCode}</td>
//                       ) : data?.products?.length > 0 ? (
//                         <td>-</td>
//                       ) : ""}
//                       <td>₹{parseFloat(item?.price?.toFixed(2))}</td>
//                       <td>{item?.quantity}</td>
//                       <td style={{ color: item.discount > 0 ? '#d32f2f' : 'inherit' }}>
//                         {item?.discount
//                           ? `${Number(item.discount).toFixed(2)}${item.discountType}`
//                           : '0%'}
//                       </td>
//                       {data?.taxes?.taxType === 'Exclusive' && (
//                         <td>{item?.discount !== 100 ? `${data.taxes.SGST}%` : '-'}</td>
//                       )}
//                       <td>₹{item?.amount}</td>
//                     </tr>
//                   ))}

//                 {data?.products?.map((item, index) => (
//                   <tr
//                     key={`product-${index}`}
//                     className={`standard-product-row ${index % 2 === 0 ? 'standard-even-row' : 'standard-odd-row'
//                       }`}
//                   >
//                     <td>{(data?.services?.length || 0) + index + 1}</td>
//                     <td>{item?.productName}</td>
//                     <td>
//                       {
//                         item?.product?.hsnCode
//                           ? `${item?.product?.hsnCode}` : "-"
//                       }
//                     </td>
//                     <td>₹{parseFloat(item?.price?.toFixed(2))}</td>
//                     <td>{item?.quantity}</td>
//                     <td style={{ color: item.discount > 0 ? '#d32f2f' : 'inherit' }}>
//                       {item?.discount
//                         ? `${parseFloat(item.discount).toFixed(2)}${item.discountType}`
//                         : '0%'}
//                     </td>
//                     {data?.taxes?.taxType === 'Exclusive' && (
//                       <td>{item?.discount !== 100 ? '18%' : '-'}</td>
//                     )}
//                     <td>₹{item?.amount}</td>
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//           </div>
//         )}

//         {isWalletBill && (
//           // <div className="standard-items-table">
//           //   <table className="standard-items">
//           //     <thead>
//           //       <tr>
//           //         <th>Wallet Recharge</th>
//           //         <th>Amount</th>
//           //       </tr>
//           //     </thead>
//           //     <tbody>
//           //       <tr className="standard-service-row standard-even-row">
//           //         <td>Amount Credited in Wallet</td>
//           //         <td>₹{data?.amountAdded}</td>
//           //       </tr>
//           //       {data?.preAdvanceUsed > 0 && (
//           //         <tr className="standard-service-row standard-odd-row">
//           //           <td>Previous Wallet Balance Used</td>
//           //           <td>-₹{data?.preAdvanceUsed}</td>
//           //         </tr>
//           //       )}
//           //       {
//           //         <tr className={`standard-service-row ${true ? 'standard-even-row' : 'standard-odd-row'}`}
//           //         >
//           //           <td>Amount Received</td>
//           //           <td>₹
//           //             {data.amountPaid.reduce((acc,payment) => {
//           //               return acc+payment?.amount;
//           //             },0)}</td>
//           //         </tr>
//           //       }
//           //     </tbody>
//           //   </table>
//           // </div>
//           <div className="standard-summary-section">
//             <div className="standard-amount-summary">
//               {!isWalletBill && (
//                 <>
//                   <div className="standard-summary-row">
//                     <span>Subtotal:</span>
//                     <span>
//                       ₹
//                       {data?.billType === 'Membership'
//                         ? parseFloat(data?.memberships?.[0]?.price || 0).toFixed(2)
//                         : data?.billType === 'Package'
//                           ? parseFloat(data?.packages?.[0]?.price || 0).toFixed(2)
//                           : parseFloat(data?.baseTotal || 0).toFixed(2)}
//                     </span>
//                   </div>

//                   {(() => {
//                     const additionalDiscount = [
//                       ...(data?.services || []),
//                       ...(data?.products || []),
//                     ]
//                       .filter((item) => item.discount > 0 && item.discount !== 100)
//                       .reduce((sum, item) => {
//                         if (item.discountType === '%') {
//                           return (
//                             sum + Math.round((item.price * item.quantity * item.discount) / 100)
//                           );
//                         } else {
//                           return sum + item.discount;
//                         }
//                       }, 0);

//                     const shouldShowAdditionalDiscount =
//                       additionalDiscount > 0 &&
//                       (!data?.coupon?.discountAmount || data.coupon.discountAmount === 0);

//                     return (
//                       shouldShowAdditionalDiscount && (
//                         <div className="standard-summary-row standard-discount-row">
//                           <span>Additional Discount:</span>
//                           <span style={{ color: '#d32f2f' }}>
//                             -₹{Math.round(additionalDiscount)}
//                           </span>
//                         </div>
//                       )
//                     );
//                   })()}

//                   {data?.useMembership && data.services?.some((s) => s.discount === 100) && (
//                     <div className="standard-summary-row standard-discount-row">
//                       <span>Membership Discount:</span>
//                       <span style={{ color: '#d32f2f' }}>
//                         -₹
//                         {data.services
//                           .filter((s) => s.discount === 100)
//                           .reduce((sum, s) => sum + s.price * s.quantity, 0)}
//                       </span>
//                     </div>
//                   )}

//                   {data?.usePackage && data.services?.some((s) => s.discount === 100) && (
//                     <div className="standard-summary-row standard-discount-row">
//                       <span>Package Discount:</span>
//                       <span style={{ color: '#d32f2f' }}>
//                         -₹
//                         {data.services
//                           .filter((s) => s.discount === 100)
//                           .reduce((sum, s) => sum + s.price * s.quantity, 0)}
//                       </span>
//                     </div>
//                   )}

//                   {data?.coupon?.discountAmount > 0 && (
//                     <div className="standard-summary-row standard-discount-row">
//                       <span>Coupon Discount ({data.coupon.couponCode}):</span>
//                       <span style={{ color: '#d32f2f' }}>-₹{data.coupon.discountAmount}</span>
//                     </div>
//                   )}

//                   {data?.rewardPointRedeemAmount > 0 && (
//                     <div className="standard-summary-row standard-discount-row">
//                       <span>Reward Points:</span>
//                       <span style={{ color: '#d32f2f' }}>-₹{data.rewardPointRedeemAmount}</span>
//                     </div>
//                   )}

//                   <div className="standard-summary-row standard-net-amount-row">
//                     <span>Net Amount (After Discounts):</span>
//                     <span>
//                       ₹
//                       {data.rewardPointRedeemAmount > 0
//                         ? data.subTotal - data.rewardPointRedeemAmount
//                         : data.subTotal}
//                     </span>
//                   </div>

//                   {data?.taxes?.taxType === 'Exclusive' && (
//                     <>
//                       <div className="standard-summary-row">
//                         <span>SGST :</span>
//                         <span>+₹{Math.round((data?.totalAmount - data?.subTotal) / 2)}</span>
//                       </div>
//                       <div className="standard-summary-row">
//                         <span>CGST :</span>
//                         <span>+₹{Math.round((data?.totalAmount - data?.subTotal) / 2)}</span>
//                       </div>
//                     </>
//                   )}
//                 </>
//               )}

//               {/* {isWalletBill && (
//               <>
//                 <div className="standard-summary-row">
//                   <span>Value of Amount:</span>
//                   <span>₹{data?.amountAdded}</span>
//                 </div>
//                 {data?.preAdvanceUsed > 0 && (
//                   <div className="standard-summary-row standard-discount-row">
//                     <span>Previous Wallet Balance Used:</span>
//                     <span style={{ color: '#d32f2f' }}>-₹{data?.preAdvanceUsed}</span>
//                   </div>
//                 )}
//                 {data?.prePaidDues > 0 && (
//                   <div className="standard-summary-row">
//                     <span>Previous Dues Paid:</span>
//                     <span>₹{data?.prePaidDues}</span>
//                   </div>
//                 )}
//               </>
//             )} */}
//               {
//                 <div className="standard-summary-row">
//                   <span>Amount Credited in Wallet:</span>
//                   <span>₹{data?.amountAdded}</span>
//                 </div>
//               }
//               {
//                 <div className="standard-summary-row">
//                   <span>Subtotal:</span>
//                   <span>₹{data?.subTotal}</span>
//                 </div>
//               }
//               {data?.taxes?.taxType === 'Exclusive' && (
//                 <>
//                   <div className="standard-summary-row">
//                     <span>SGST :</span>
//                     <span>+₹{Math.round((data?.totalAmount - data?.subTotal) / 2)}</span>
//                   </div>
//                   <div className="standard-summary-row">
//                     <span>CGST :</span>
//                     <span>+₹{Math.round((data?.totalAmount - data?.subTotal) / 2)}</span>
//                   </div>
//                 </>
//               )}
//               {
//                 <div className="standard-summary-row standard-total-row">
//                   <span>Total Amount</span>
//                   <span>₹{data?.amountPayable}</span>
//                 </div>
//               }

//               {
//                 <div className="standard-summary-row">
//                   <span>Amount Received:</span>
//                   <span style={{ color: '#2e7d32', fontWeight: 'bold' }}>
//                     ₹{data?.amountPaid?.reduce((acc, p) => acc + Number(p.amount), 0)}
//                   </span>
//                 </div>
//               }

//               {/* {data.paidDues > 0 && (
//               <div className="standard-summary-row standard-due-row">
//                 <span>Due Balance:</span>
//                 <span style={{ color: '#d32f2f', fontWeight: 'bold' }}>₹{data.paidDues}</span>
//               </div>
//             )} */}

//               {data?.remainingWalletAmount && (
//                 <div className="standard-summary-row">
//                   <span>Remaining Wallet Balance:</span>
//                   <span style={{ color: '#2e7d32', fontWeight: 'bold' }}>
//                     ₹{data?.remainingWalletAmount}
//                   </span>
//                 </div>
//               )}
//             </div>
//           </div>
//         )}

//         <div className="standard-summary-section">
//           <div className="standard-amount-summary">
//             {!isWalletBill && (
//               <>
//                 <div className="standard-summary-row">
//                   <span>Subtotal:</span>
//                   <span>
//                     ₹
//                     {data?.billType === 'Membership'
//                       ? parseFloat(data?.memberships?.[0]?.price || 0).toFixed(2)
//                       : data?.billType === 'Package'
//                         ? parseFloat(data?.packages?.[0]?.price || 0).toFixed(2)
//                         : parseFloat(data?.baseTotal || 0).toFixed(2)}
//                   </span>
//                 </div>

//                 {(() => {
//                   const additionalDiscount = [...(data?.services || []), ...(data?.products || [])]
//                     .filter((item) => item.discount > 0 && item.discount !== 100)
//                     .reduce((sum, item) => {
//                       if (item.discountType === '%') {
//                         return sum + Math.round((item.price * item.quantity * item.discount) / 100);
//                       } else {
//                         return sum + item.discount;
//                       }
//                     }, 0);

//                   const shouldShowAdditionalDiscount =
//                     additionalDiscount > 0 &&
//                     (!data?.coupon?.discountAmount || data.coupon.discountAmount === 0);

//                   return (
//                     shouldShowAdditionalDiscount && (
//                       <div className="standard-summary-row standard-discount-row">
//                         <span>Additional Discount:</span>
//                         <span style={{ color: '#d32f2f' }}>-₹{Math.round(additionalDiscount)}</span>
//                       </div>
//                     )
//                   );
//                 })()}

//                 {data?.useMembership && data.services?.some((s) => s.discount === 100) && (
//                   <div className="standard-summary-row standard-discount-row">
//                     <span>Membership Discount:</span>
//                     <span style={{ color: '#d32f2f' }}>
//                       -₹
//                       {data.services
//                         .filter((s) => s.discount === 100)
//                         .reduce((sum, s) => sum + s.price * s.quantity, 0)}
//                     </span>
//                   </div>
//                 )}

//                 {data?.packageUniqueId?.length > 0 &&
//                   data.services?.some((s) => s.discount === 100) && (
//                     <div className="standard-summary-row standard-discount-row">
//                       <span>Package Discount:</span>
//                       <span style={{ color: '#d32f2f' }}>
//                         -₹
//                         {data.services
//                           .filter((s) => s.discount === 100)
//                           .reduce((sum, s) => sum + s.price * s.quantity, 0)}
//                       </span>
//                     </div>
//                   )}

//                 {data?.coupon?.discountAmount > 0 && (
//                   <div className="standard-summary-row standard-discount-row">
//                     <span>Coupon Discount ({data.coupon.couponCode}):</span>
//                     <span style={{ color: '#d32f2f' }}>-₹{data.coupon.discountAmount}</span>
//                   </div>
//                 )}

//                 {data?.rewardPointRedeemAmount > 0 && (
//                   <div className="standard-summary-row standard-discount-row">
//                     <span>Reward Points:</span>
//                     <span style={{ color: '#d32f2f' }}>-₹{data.rewardPointRedeemAmount}</span>
//                   </div>
//                 )}

//                 <div className="standard-summary-row standard-net-amount-row">
//                   <span>Net Amount (After Discounts):</span>
//                   <span>
//                     ₹
//                     {data.rewardPointRedeemAmount > 0
//                       ? data.subTotal - data.rewardPointRedeemAmount
//                       : data.subTotal}
//                   </span>
//                 </div>

//                 {data?.taxes?.taxType === 'Exclusive' && (
//                   <>
//                     <div className="standard-summary-row">
//                       <span>SGST :</span>
//                       <span>+₹{Math.round((data?.totalAmount - data?.subTotal) / 2)}</span>
//                     </div>
//                     <div className="standard-summary-row">
//                       <span>CGST :</span>
//                       <span>+₹{Math.round((data?.totalAmount - data?.subTotal) / 2)}</span>
//                     </div>
//                   </>
//                 )}
//               </>
//             )}

//             {/* {isWalletBill && (
//               <>
//                 <div className="standard-summary-row">
//                   <span>Value of Amount:</span>
//                   <span>₹{data?.amountAdded}</span>
//                 </div>
//                 {data?.preAdvanceUsed > 0 && (
//                   <div className="standard-summary-row standard-discount-row">
//                     <span>Previous Wallet Balance Used:</span>
//                     <span style={{ color: '#d32f2f' }}>-₹{data?.preAdvanceUsed}</span>
//                   </div>
//                 )}
//                 {data?.prePaidDues > 0 && (
//                   <div className="standard-summary-row">
//                     <span>Previous Dues Paid:</span>
//                     <span>₹{data?.prePaidDues}</span>
//                   </div>
//                 )}
//               </>
//             )} */}

//             {!isWalletBill && (
//               <div className="standard-summary-row standard-total-row">
//                 <span>Total Amount</span>
//                 <span>₹{data?.amountPayable}</span>
//               </div>
//             )}

//             {!isWalletBill && (
//               <div className="standard-summary-row">
//                 <span>Amount Received:</span>
//                 <span style={{ color: '#2e7d32', fontWeight: 'bold' }}>
//                   ₹{data?.amountPaid?.reduce((acc, p) => acc + Number(p.amount), 0)}
//                 </span>
//               </div>
//             )}

//             {data.paidDues > 0 && (
//               <div className="standard-summary-row standard-due-row">
//                 <span>Due Balance:</span>
//                 <span style={{ color: '#d32f2f', fontWeight: 'bold' }}>₹{data.paidDues}</span>
//               </div>
//             )}

//             {data?.remainingWalletAmount && (
//               <div className="standard-summary-row">
//                 <span>Remaining Wallet Balance:</span>
//                 <span style={{ color: '#2e7d32', fontWeight: 'bold' }}>
//                   ₹{data?.remainingWalletAmount}
//                 </span>
//               </div>
//             )}
//           </div>
//         </div>

//         <div className="standard-amount-in-words">
//           <p>
//             <strong>Amount in words:</strong> {getAmountInWords(data.amountPayable)}
//           </p>
//         </div>

//         <div className="standard-footer-section">
//           <div className="standard-terms-conditions">
//             <h4>Terms & Conditions:</h4>
//             <ul>
//               <li>Goods once sold will not be taken back</li>
//               <li>Subject to local Jurisdiction</li>
//               <li>Thank you for your business!</li>
//             </ul>
//           </div>
//           <div className="standard-signature">
//             {data?.branchDetails?.signature && (
//               <img
//                 src={data?.branchDetails?.signature?.url}
//                 alt="Signature"
//                 className="standard-signature-logo"
//               />
//             )}
//             <div className="standard-signature-line"></div>
//             <p>Authorized Signatory</p>
//             <p>{data?.branchDetails?.branchName}</p>
//           </div>
//         </div>

//         <div className="standard-powered-by">
//           <p>
//             Powered by <Link to="https://yoursalon.in/">YourSalon.in</Link>
//           </p>
//         </div>
//       </div>

//       <div className="standard-action-buttons">
//         <Button
//           variant="contained"
//           className="standard-whatsapp-button"
//           onClick={whatsAppBillHandler}
//           startIcon={<WhatsAppIcon />}
//         >
//           WhatsApp
//         </Button>
//         <Button variant="contained" className="standard-print-button" onClick={printBillHandler}>
//           Print Bill
//         </Button>
//       </div>
//     </div>
//   );
// };

// export default BillPdf;

import React from 'react';
import './BillPdf.css';
import { Button } from '@mui/material';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import { Link } from 'react-router-dom';
import { useReactToPrint } from 'react-to-print';
import { useRef } from 'react';
import numWords from 'num-words';
import { MessageData } from './MessageData';
import { changeDateFormate } from "../../../utils/dateutils"

const BillPdf = ({ data, branchData, printRef, helpers }) => {
  const { capitalizeWords } = helpers || {};

  const printBillHandler = useReactToPrint({
    content: () => printRef.current,
    documentTitle: `${data?.invoice}`,
  });

  const whatsAppBillHandler = () => {
    const url = MessageData(data, {}, branchData, data.feedbackUrl, data.billUrl);
    window.open(url, '_blank');
  };

  const getAmountInWords = (amount) =>
    `${capitalizeWords(numWords(Math.round(amount)))} Rupees Only`;

  // Bill type conditions
  const isMembershipBill = data?.billType === 'Membership';
  const isPackageBill = data?.billType === 'Package';
  const isWalletBill = data?.billType === 'Wallet';
  const isRegularBill = data?.billType === 'Bill';

  // Check if remainingServices exists and has items
  const hasRemainingServices = data?.remainingServices?.length > 0;
  const hasDueHistory = data?.dueBillHistory?.length > 0;
  const renderDueHistoryTable = () => {
    if (!hasDueHistory) return null;
    let remainingAmount = 0;
    let totalAmount = data.paidDues - remainingAmount;

    return (
      <div className="standard-services-list">
        <h6 style={{ marginTop: '10px' }}>
          {data?.dueBillHistory.length > 0 ? 'Due Cleared History:' : ''}
        </h6>
        <div className="remaining-services-table">
          <table>
            <thead>
              <tr>
                <th>Date</th>
                <th style={{ textAlign: 'center' }}>Total</th>
                <th style={{ textAlign: 'center' }}>Paid</th>
                <th style={{ textAlign: 'center' }}>Payment Mode</th>
                <th style={{ textAlign: 'center' }}>Due</th>
              </tr>
            </thead>
            <tbody>
              {data.dueBillHistory.map((history, index) => {
                remainingAmount = totalAmount - history.paidAmount;
                const row = (
                  <tr key={index}>
                    <td>{changeDateFormate(history.paymentDate)}</td>
                    <td style={{ textAlign: 'center' }}>{totalAmount}</td>
                    <td style={{ textAlign: 'center' }}>{history.paidAmount}</td>
                    <td style={{ textAlign: 'center' }}>{history.paymentType}</td>
                    <td style={{ textAlign: 'center' }}>{remainingAmount}</td>
                  </tr>
                );
                totalAmount = remainingAmount;
                return row;
              })}
            </tbody>
          </table>
        </div>
      </div>
    );
  };

  const renderRemainingServicesTable = () => {
    if (!hasRemainingServices) return null;

    return (
      <div className="standard-services-list">
        <h6 style={{ marginTop: '10px' }}>{data?.packageUniqueId.length > 0 ? 'Remaining Package Services:' : "Remaining Membership Services:"}</h6>
        <div className="remaining-services-table">
          <table>
            <thead>
              <tr>
                <th>Service Name</th>
                <th>Count</th>
              </tr>
            </thead>
            <tbody>
              {data.remainingServices.map((service, index) => (
                <tr key={index}>
                  <td>• {service.serviceName}</td>
                  <td style={{ textAlign: 'center' }}>
                    {service.count || 1}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    );
  };

  const renderServicesList = () => {
    if (isMembershipBill && data?.membershipDetails) {
      const { membershipType, servicesOffered, discount } = data.membershipDetails;

      if (membershipType === 'serviceType' && servicesOffered?.length > 0) {
        return (
          <div className="standard-services-list">
            <h6>Membership Services:</h6>
            <div className="membership-services-table">
              <table>
                <thead>
                  <tr>
                    <th>Service Name</th>
                    <th>Count</th>
                  </tr>
                </thead>
                <tbody>
                  {servicesOffered.map((serviceItem, index) => (
                    <tr key={index}>
                      <td>• {serviceItem.service?.serviceName}</td>
                      <td style={{ textAlign: 'center' }}>{serviceItem.availableCount || '0'}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        );
      }

      if (membershipType === 'discountType' && discount) {
        return (
          <div className="standard-services-list">
            <h6>Membership Benefits:</h6>
            <div className="discount-benefits-table">
              <table>
                <tbody>
                  {discount.discountOnService > 0 && (
                    <tr>
                      <td><strong>Discount on Service:</strong></td>
                      <td>{discount.discountOnService}{discount.serviceDiscountType === '%' ? '%' : '₹'} off on all services</td>
                    </tr>
                  )}
                  {discount.discountOnProduct > 0 && (
                    <tr>
                      <td><strong>Discount on Product:</strong></td>
                      <td>{discount.discountOnProduct}{discount.productDiscountType === '%' ? '%' : '₹'} off on all products</td>
                    </tr>
                  )}
                  {discount.minBillAmount > 0 && (
                    <tr>
                      <td><strong>Minimum Bill Amount:</strong></td>
                      <td>₹{discount.minBillAmount}</td>
                    </tr>
                  )}
                  {discount.availableCount > 0 && (
                    <tr>
                      <td><strong>Available  Count:</strong></td>
                      <td>{discount.availableCount} Count</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        );
      }
    }

    if (isPackageBill && data?.servicesPackage?.services) {
      return (
        <div className="standard-services-list">
          <h6>Package Services</h6>
          <div className="package-services-table">
            <table>
              <thead>
                <tr>
                  <th>Service Name</th>
                  <th>Count</th>
                </tr>
              </thead>
              <tbody>
                {data.servicesPackage.services.map((service, index) => (
                  <tr key={index}>
                    <td>• {service.serviceName}</td>
                    <td style={{ textAlign: 'center' }}>1</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      );
    }

    return null;
  };

  const renderMainTable = () => {
    if (isWalletBill) {
      return renderWalletTable();
    }
    const showGstColumn = !!data?.branchDetails?.gstNumber || !!branchData?.gstNumber;

    const hasGst = Math.round((data?.totalAmount || 0) - (data?.subTotal || 0)) > 0;
    // const showGstColumn = (data?.taxes?.taxType === 'Exclusive' || data?.taxes?.taxType === 'Ingst') && hasGst;

    return (
      <div className="standard-items-table">
        <table className="standard-items">
          <thead>
            <tr>
              <th>#</th>
              <th>Description</th>
              {data?.products?.length > 0 ? <th>HSN Code</th> : ''}
              {data?.products?.length > 0 ? <th>Mrp</th> : ''}
              <th>Rate</th>
              <th>Qty</th>
              <th>Discount</th>
              {showGstColumn && <th>Gst</th>}
              <th>Amount</th>
            </tr>
          </thead>
          <tbody>
            {renderTableRows(showGstColumn)}
          </tbody>
        </table>
      </div>
    );
  };

  const renderTableRows = (showGstColumn) => {
    // if (isMembershipBill) {
    //   return data?.memberships?.map((item, index) => (
    //     <TableRow
    //       key={`membership-${index}`}
    //       index={index}
    //       description={item?.membershipName}
    //       price={item?.price}
    //       quantity={item?.quantity}
    //       discount={item?.discount}
    //       discountType={item?.discountType}
    //       amount={item?.amount || calculateAmount(item)}
    //       isEven={index % 2 === 0}
    //       showGst={showGstColumn}
    //       gstRate={data?.taxes?.SGST}
    //     />
    //   ));
    if (isMembershipBill) {
  return data?.memberships?.map((item, index) => (
    <TableRow
      key={`membership-${index}`}
      index={index}
      description={item?.membershipName}
      price={item?.price}
      quantity={item?.quantity}
      discount={item?.discount}
      discountType={item?.discountType}
      amount={item?.amount || calculateAmount(item)}
      isEven={index % 2 === 0}
      showGst={showGstColumn}
      gstRate={data?.taxes?.SGST}
taxStatus={item?.taxStatus}
      gstPercent={item?.gstPercent}
            gstValue={item?.gstValue}
    />
  ));
    }

    // if (isPackageBill) {
    //   return data?.packages?.map((item, index) => (
    //     <TableRow
    //       key={`package-${index}`}
    //       index={index}
    //       description={item?.packageName}
    //       price={item?.price}
    //       quantity={item?.quantity}
    //       discount={item?.discount}
    //       discountType={item?.discountType}
    //       amount={item?.amount || calculateAmount(item)}
    //       isEven={index % 2 === 0}
    //       showGst={showGstColumn}
    //       gstRate={data?.taxes?.SGST}
    //     />
    //   ));
    if (isPackageBill) {
  return data?.packages?.map((item, index) => (
    <TableRow
      key={`package-${index}`}
      index={index}
      description={item?.packageName}
      price={item?.price}
      quantity={item?.quantity}
      discount={item?.discount}
      discountType={item?.discountType}
      amount={item?.amount || calculateAmount(item)}
      isEven={index % 2 === 0}
      showGst={showGstColumn}
      gstRate={data?.taxes?.SGST}
      // taxStatus={item?.taxStatus}   // ← add this
       taxStatus={item?.taxStatus}
      gstPercent={item?.gstPercent}
            gstValue={item?.gstValue}
    />
  ));
    }

    // Regular bill with services and products
    return (
      <>
        {data?.services?.map((item, index) => (
          <ServiceRow
            key={`service-${index}`}
            item={item}
            index={index}
            showGst={showGstColumn}
            gstRate={data?.taxes?.SGST}
            showHsn={data?.products?.length > 0}
            showMrp={data?.products?.length > 0}
          />
        ))}
        {data?.products?.map((item, index) => (
          <ProductRow
            key={`product-${index}`}
            item={item}
            index={(data?.services?.length || 0) + index}
            showGst={showGstColumn}
            showMrp={data?.products?.length > 0}
          />
        ))}
      </>
    );
  };

  const renderWalletTable = () => {
    return (
      <div className="standard-items-table">
        <table className="standard-items">
          <thead>
            <tr>
              <th>Wallet Recharge</th>
              <th>Amount</th>
            </tr>
          </thead>
          <tbody>
            <tr className="standard-service-row standard-even-row">
              <td>Amount Credited in Wallet</td>
              <td>₹{data?.amountAdded}</td>
            </tr>
            {data?.preAdvanceUsed > 0 && (
              <tr className="standard-service-row standard-odd-row">
                <td>Previous Wallet Balance Used</td>
                <td>-₹{data?.preAdvanceUsed}</td>
              </tr>
            )}
            <tr className="standard-service-row standard-even-row">
              <td>Amount Received</td>
              <td>₹{data.amountPaid.reduce((acc, payment) => acc + payment?.amount, 0)}</td>
            </tr>
          </tbody>
        </table>
      </div>
    );
  };

  const calculateAmount = (item) => {
    // const discountAmount = item.discountType === '%'
    //   ? (item.price * item.discount) / 100
    //   : item.discount;
    // return item.price - discountAmount;
     const price = Number(item.price) || 0;
    const quantity = Number(item.quantity) || 1;
    if (item.discountType === '%') {
      const discountAmount = (price * item.discount) / 100;
      return (price - discountAmount) * quantity;
    } else {
      // INR discount: flat amount deducted from total
      return Math.max(0, (price * quantity) - (Number(item.discount) || 0));
    }
  };

  // Reusable table row component
  // const TableRow = ({
  //   index,
  //   description,
  //   price,
  //   quantity,
  //   discount,
  //   discountType,
  //   amount,
  //   isEven,
  //   showGst,
  //   gstRate
  // }) => (
  //   <tr className={`standard-service-row ${isEven ? 'standard-even-row' : 'standard-odd-row'}`}>
  //     <td>{index + 1}</td>
  //     <td>{description}</td>
  //     <td>₹{parseFloat(price).toFixed(2)}</td>
  //     <td>{quantity}</td>
  //     <td style={{ color: discount > 0 ? '#d32f2f' : 'inherit' }}>
  //       {discount ? `${discount}${discountType}` : '0%'}
  //     </td>
  //     {showGst && <td>{gstRate}%</td>}
  //     <td>₹{amount}</td>
  //   </tr>
  const TableRow = ({
  index,
  description,
  price,
  quantity,
  discount,
  discountType,
  amount,
  isEven,
  showGst,
  gstRate,
   taxStatus,   // ← add this prop
  gstPercent,
  gstValue  // ← add this prop
}) => {
  // const effectiveGstRate = gstRate || 0;
  //   const effectiveGstRate = Number(gstPercent > 0 ? gstPercent : (gstRate || 0));
  // const displayedPrice = (taxStatus === 'withTax' && effectiveGstRate > 0)
  //   ? (Number(price || 0) / (1 + effectiveGstRate / 100)).toFixed(2)
  const displayedPrice = (taxStatus === 'withTax' && gstPercent > 0)
    ? (Number(price || 0) / (1 + (gstPercent || 0) / 100)).toFixed(2)
    : parseFloat(price || 0).toFixed(2);

  return (
    <tr className={`standard-service-row ${isEven ? 'standard-even-row' : 'standard-odd-row'}`}>
      <td>{index + 1}</td>
      <td>{description}</td>
      <td>₹{displayedPrice}</td>  {/* ← changed */}
      <td>{quantity}</td>
      <td style={{ color: discount > 0 ? '#d32f2f' : 'inherit' }}>
        {discount ? `${discount}${discountType}` : '0%'}
      </td>
      {showGst && (
        <td>
          {/* {discount !== 100 */}
                    {!(Number(discount) === 100 && discountType === '%')
            // ? `${effectiveGstRate}% (₹${(
            //     ((amount || 0) * effectiveGstRate) / 100
            //   ).toFixed(2)})`
                        ? `${gstPercent || 0}% (₹${(gstValue || 0).toFixed(2)})`
            : '-'}
        </td>
      )}
      <td>₹{amount}</td>
    </tr>
  );
};
  

  // Service row component for regular bills
  // const ServiceRow = ({ item, index, showGst, gstRate, showHsn, showMrp }) => (
  //   <tr
  //     className={`standard-service-row ${index % 2 === 0 ? 'standard-even-row' : 'standard-odd-row'}`}
  //     style={item.discount === 100 ? { backgroundColor: '#bfc7f1' } : {}}
  //   >
  //     <td>{index + 1}</td>
  //     <td>
  //       {item?.serviceName}
  //       {item?.serviceProviderName && (
  //         <div className="standard-service-provider">
  //           By: {item?.serviceProviderName}
  //         </div>
  //       )}
  //     </td>
  //     {showHsn && <td>{item?.hsnCode || '-'}</td>}
  //     {showMrp && <td>{'-'}</td>}
  //     <td>₹{parseFloat(item?.price?.toFixed(2))}</td>
  //     <td>{item?.quantity}</td>
  //     <td style={{ color: item.discount > 0 ? '#d32f2f' : 'inherit' }}>
  //       {item?.discount
  //         ? `${Number(item.discount).toFixed(2)}${item.discountType}`
  //         : '0%'}
  //     </td>
  //     {showGst && (
  //       <td>
  //         {item?.discount !== 100 && item?.taxStatus !== 'noGst'
  //           ? `${gstRate || 0}%`
  //           : '-'}
  //       </td>
  //     )}
  //     <td>₹{item?.amount}</td>
  //   </tr>
  // );
   const ServiceRow = ({ item, index, showGst, gstRate, showHsn, showMrp }) => {
  // Calculate taxable (displayed) price — same logic as AddBill
  // const effectiveGstRate = gstRate || 0;
  //   const effectiveGstRate = Number(item?.gstPercent > 0 ? item.gstPercent : (gstRate || 0));
  // const displayedPrice = (item?.taxStatus === 'withTax' && effectiveGstRate > 0)
  //   ? (Number(item?.price || 0) / (1 + effectiveGstRate / 100)).toFixed(2)
  const displayedPrice = (item?.taxStatus === 'withTax' && item?.gstPercent > 0)
    ? (Number(item?.price || 0) / (1 + item.gstPercent / 100)).toFixed(2)
    : parseFloat(item?.price || 0).toFixed(2);

  return (
    <tr
      className={`standard-service-row ${index % 2 === 0 ? 'standard-even-row' : 'standard-odd-row'}`}
      // style={item.discount === 100 ? { backgroundColor: '#bfc7f1' } : {}}
            style={Number(item.discount) === 100 && item.discountType === '%' ? { backgroundColor: '#bfc7f1' } : {}}
    >
      <td>{index + 1}</td>
      <td>
        {item?.serviceName}
        {item?.serviceProviderName && (
          <div className="standard-service-provider">
            By: {item?.serviceProviderName}
          </div>
        )}
      </td>
      {showHsn && <td>{item?.hsnCode || '-'}</td>}
      {/* {showMrp && <td>{'-'}</td>} */}
      {showMrp && <td>₹{item?.price || '-'}</td>}
      <td>₹{displayedPrice}</td>  {/* ← changed from item?.price */}
      <td>{item?.quantity}</td>
      <td style={{ color: item.discount > 0 ? '#d32f2f' : 'inherit' }}>
        {item?.discount
          ? `${Number(item.discount).toFixed(2)}${item.discountType}`
          : '0%'}
      </td>
      {showGst && (
        <td>
        {!(Number(item?.discount) === 100 && item?.discountType === '%') && item?.taxStatus !== 'noGst'
                        ? `${item?.gstPercent || 0}% (₹${(item?.gstValue || 0).toFixed(2)})`
            : '-'}
        </td>
      )}
      <td>₹{item?.amount}</td>
    </tr>
  );
};
  // Product row component for regular bills
  // const ProductRow = ({ item, index, showGst, showMrp }) => (
  //   <tr
  //     className={`standard-product-row ${index % 2 === 0 ? 'standard-even-row' : 'standard-odd-row'}`}
  //   >
  //     <td>{index + 1}</td>
  //     <td>{item?.productName}</td>
  //     <td>{item?.product?.hsnCode ? `${item?.product?.hsnCode}` : "-"}</td>
  //     {showMrp && (<td>{item?.product?.mrp ? `${item?.product?.mrp}` : "-"}</td>)}
  //     <td>₹{parseFloat(item?.price?.toFixed(2))}</td>
  //     <td>{item?.quantity}</td>
  //     <td style={{ color: item.discount > 0 ? '#d32f2f' : 'inherit' }}>
  //       {item?.discount
  //         ? `${parseFloat(item.discount).toFixed(2)}${item.discountType}`
  //         : '0%'}
  //     </td>
  //     {/* {showGst && (
  //       <td>{item?.discount !== 100 ? '18%' : '-'}</td> very careful here as it was showoing previously
  //     )} */}
  //     {
  //       showGst &&
  //       // <td>{item?.product?.GST ?? 18}%</td>
  //               <td>{item?.discount !== 100 ? `${item?.product?.GST ?? 18}%` : '-'}</td>

  //     }
  //     <td>₹{item?.amount}</td>
  //   </tr>
  // );
const ProductRow = ({ item, index, showGst, showMrp }) => {
  // const productGstRate = Number(item?.product?.GST ?? item?.gst ?? 18);
    const productGstRate = Number(item?.gstPercent > 0 ? item.gstPercent : (item?.product?.GST ?? item?.gst ?? 18));
  const displayedProdPrice = (item?.taxStatus === 'withTax' && productGstRate > 0)
    ? (Number(item?.price || 0) / (1 + productGstRate / 100)).toFixed(2)
    : parseFloat(item?.price || 0).toFixed(2);

  return (
    <tr
      className={`standard-product-row ${index % 2 === 0 ? 'standard-even-row' : 'standard-odd-row'}`}
    >
      <td>{index + 1}</td>
      <td>{item?.productName}</td>
      <td>{item?.product?.hsnCode ? `${item?.product?.hsnCode}` : "-"}</td>
{/* {showMrp && (<td>{item?.product?.price ? `${item?.product?.price}` : "-"}</td>)} */}
      {showMrp && (<td>₹{parseFloat(item?.price || 0).toFixed(2)}</td>)}
      <td>₹{displayedProdPrice}</td>  {/* ← changed */}
      <td>{item?.quantity}</td>
      <td style={{ color: item.discount > 0 ? '#d32f2f' : 'inherit' }}>
        {item?.discount
          ? `${parseFloat(item.discount).toFixed(2)}${item.discountType}`
          : '0%'}
      </td>
      {showGst && (
        <td>
           {!(Number(item?.discount) === 100 && item?.discountType === '%')
                       ? `${item?.gstPercent || 0}% (₹${(item?.gstValue || 0).toFixed(2)})`
            : '-'}
        </td>
      )}
      <td>₹{item?.amount}</td>
    </tr>
  );
};
  return (
    <div className="print-section standard-bill-container">
      <div ref={printRef} className="standard-bill-content">
        {/* Header Section */}
        <div className="standard-branch-name-container">
          <h1 className="standard-branch-name">{data?.branchDetails?.branchName}</h1>
        </div>

        <div className="standard-bill-header">
          <div className="standard-header-left">
            <div className="standard-logo-container">
              {data?.branchDetails?.logo && (
                // <img src={data?.branchDetails?.logo?.url} alt="" className="standard-branch-logo" />
   <img
  src={data?.branchDetails?.logo?.url}
  alt=""
  crossOrigin="anonymous"
  className="standard-branch-logo"
/>   )}
            </div>
          </div>

          <div className="standard-header-right">
            <div className="standard-branch-details">
              {data?.branchDetails?.address && (
                <p className="standard-detail-item">
                  <span className="standard-detail-label">Address: </span>
                  {data?.branchDetails?.address}
                </p>
              )}
              {data?.branchDetails?.branchPhone && (
                <p className="standard-detail-item">
                  <span className="standard-detail-label">Phone: </span>
                  {data?.branchDetails?.branchPhone}
                </p>
              )}
              {data?.branchDetails?.branchEmail && (
                <p className="standard-detail-item">
                  <span className="standard-detail-label">Email: </span>
                  {data?.branchDetails?.branchEmail}
                </p>
              )}
              {data?.taxes?.taxType === 'Exclusive' && data?.branchDetails?.gstNumber && (
                <p className="standard-detail-item">
                  <span className="standard-detail-label">GSTIN: </span>
                  {data?.branchDetails?.gstNumber}
                </p>
              )}
            </div>
          </div>
        </div>

        {/* Client Info Section */}
        <div className="standard-client-info-section">
          <div className="standard-client-details">
            <h3 className="standard-section-title">Bill To:</h3>
            <p className="standard-client-name">{data?.clientName}</p>
            <p className="standard-client-contact">Contact: {data?.clientNumber}</p>
            {data?.billType === 'Package' && (
              <p className="standard-invoice-time">
                <strong>Bill Type:</strong> Package Bill
              </p>
            )}
            {data?.billType === 'Membership' && (
              <p className="standard-invoice-time">
                <strong>Bill Type:</strong> Membership Bill
              </p>
            )}
                {branchData?.gstNumber && (
              <>
                <p className="standard-client-contact">
                  <strong>Address:</strong> {data?.clientAddress}
                </p>
                <p className="standard-client-contact">
                  <strong>Gst Number:</strong> {data?.clientGstNumber}
                </p>
                <p className="standard-client-contact">
                  <strong>Place of supply:</strong> {data?.clientPos}
                </p>
              </>
            )}
          </div>
          <div className="standard-invoice-details">
            <h3 className="standard-section-title">Invoice Details</h3>
            <p className="standard-invoice-number">
              <strong>Invoice #:</strong> {data?.invoice}
            </p>
            <p className="standard-invoice-date">
              <strong>Date:</strong> {data?.formattedDate}
            </p>
            <p className="standard-invoice-time">
              <strong>Time:</strong> {data?.formattedTime}
            </p>
          </div>
        </div>

        {/* Main Table Section */}
        {renderMainTable()}

        {/* Services List for Membership and Package */}
        {(isMembershipBill || isPackageBill) && renderServicesList()}

        {/* Remaining Services Table */}
        {hasRemainingServices && renderRemainingServicesTable()}

        {data?.billType === 'Package' && (
          <p className="standard-invoice-time" style={{ marginTop: '10px' }}>
            <strong>Valid Till:</strong> {changeDateFormate(data?.endDate)}
          </p>
        )}
        {data?.billType === 'Membership' && (
          <p className="standard-invoice-time" style={{ marginTop: '10px' }}>
            <strong>Valid Till:</strong> {changeDateFormate(data?.endDate)}
          </p>
        )}
        {/* Summary Section */}
        <SummarySection data={data} isWalletBill={isWalletBill} />
        {hasDueHistory && renderDueHistoryTable()}

        {/* Amount in Words */}
        <div className="standard-amount-in-words">
          <p>
            <strong>Amount in words:</strong> {getAmountInWords(data.amountPayable)}
          </p>
        </div>
        <div className="standard-amount-in-words">
          <p>
            <strong>Note :</strong> {data.noteForClient}
          </p>
        </div>

        {/* Footer Section */}
        <div className="standard-footer-section">
          <div className="standard-terms-conditions">
            <h4>Terms & Conditions:</h4>
            <ul>
              <li>Goods once sold will not be taken back</li>
              <li>Subject to local Jurisdiction</li>
              <li>Thank you for your business!</li>
            </ul>
          </div>
          <div className="standard-signature">
            {data?.branchDetails?.signature && (
              <img
                src={data?.branchDetails?.signature?.url}
                alt="Signature"
                className="standard-signature-logo"
              />
            )}
            <div className="standard-signature-line"></div>
            <p>Authorized Signatory</p>
            <p>{data?.branchDetails?.branchName}</p>
          </div>
        </div>

        <div className="standard-powered-by">
          <p>
            Powered by <Link to="https://yoursalon.in/">YourSalon.in</Link>
          </p>
        </div>
      </div>

      {/* Action Buttons */}
      <div className="standard-action-buttons">
        <Button
          variant="contained"
          className="standard-whatsapp-button"
          onClick={whatsAppBillHandler}
          startIcon={<WhatsAppIcon />}
        >
          WhatsApp
        </Button>
        <Button variant="contained" className="standard-print-button" onClick={printBillHandler}>
          Print Bill
        </Button>
      </div>
    </div>
  );
};

// Separate Summary Section Component for better organization
// const SummarySection = ({ data, isWalletBill }) => {
//   const calculateAdditionalDiscount = () => {
//     // return [...(data?.services || []), ...(data?.products || [])]
//     //   .filter((item) => item.discount > 0 && item.discount !== 100)
//     //   .reduce((sum, item) => {
//     //     if (item.discountType === '%') {
//     //       return sum + Math.round((item.price * item.quantity * item.discount) / 100);
//     //     } else {
//     //       return sum + item.discount;
//     //     }
//     //   }, 0);

//     const totalDiscount = [...(data?.services || []), ...(data?.products || [])]
//       .filter((item) => {
//         const isFullPercentDiscount = Number(item.discount) === 100 && item.discountType === '%';
//         return Number(item.discount) > 0 && !isFullPercentDiscount;
//       })
//       .reduce((sum, item) => {
//         const lineTotal = (Number(item.price) || 0) * (Number(item.quantity) || 0);
//         const finalAmount = Number(item.amount) || 0;
//         const discountVal = lineTotal - finalAmount;
//         return sum + discountVal;
//       }, 0);

//     return totalDiscount;
//   };
const SummarySection = ({ data, isWalletBill }) => {
  const totalGstFromItems = [
    ...(data?.services || []),
    ...(data?.products || []),
    ...(data?.memberships || []),
    ...(data?.packages || []),
  ].reduce((sum, item) => sum + (Number(item?.gstValue) || 0), 0);

  const totalGstValue = totalGstFromItems > 0 ? totalGstFromItems : Math.max(0, Number(data?.totalAmount || 0) - Number(data?.subTotal || 0));

  // Calculate taxable subtotal = sum of (amount with GST extracted if withTax)
  const calculateTaxableSubTotal = () => {
    const allItems = [
      ...(data?.services || []),
      ...(data?.products || []),
      ...(data?.memberships || []),
      ...(data?.packages || []),
    ];

    return allItems.reduce((sum, item) => {
      // const amount = Number(item?.amount || 0);
       const price = Number(item?.price || 0);
      const quantity = Number(item?.quantity ?? 1);
      const taxStatus = item?.taxStatus || 'noGst';
      // for services/memberships/packages use taxes.SGST, for products use item.gst
      const isProduct = !item?.serviceName && !item?.membershipName && !item?.packageName;
         const gstRate = Number(item?.gstPercent > 0 ? item.gstPercent : (isProduct
        ? (item?.product?.GST ?? item?.gst ?? 18)
        : (data?.taxes?.SGST || 0)));

      let taxableValue = price;

      if (taxStatus === 'withTax' && gstRate > 0) {
      //   // GST inclusive: extract GST from amount
      //   // taxable = amount / (1 + gstRate/100)
      //   return sum + (amount / (1 + gstRate / 100));
      // } else {
      //   // withoutTax or noGst: amount is already taxable
      //   return sum + amount;
              taxableValue = Number((price / (1 + gstRate / 100)).toFixed(2));
      }
            return sum + (taxableValue * quantity);
    }, 0);
  };

  const taxableSubTotal = calculateTaxableSubTotal();

  const calculateAdditionalDiscount = () => {  const totalDiscount = [...(data?.services || []), ...(data?.products || [])]
      .filter((item) => {
        const isFullPercentDiscount = Number(item.discount) === 100 && item.discountType === '%';
        return Number(item.discount) > 0 && !isFullPercentDiscount;
      })
      .reduce((sum, item) => {
        const price = Number(item?.price || 0);
        const quantity = Number(item?.quantity || 1);
        const amount = Number(item?.amount || 0);
        const taxStatus = item?.taxStatus || 'noGst';
        const isProduct = !item?.serviceName && !item?.membershipName && !item?.packageName;
        const gstRate = Number(item?.gstPercent > 0 ? item.gstPercent : (isProduct
          ? (item?.product?.GST ?? item?.gst ?? 18)
          : (data?.taxes?.SGST || 0)));

        let lineTotal = price * quantity;
        let finalAmount = amount;

        if (taxStatus === 'withTax' && gstRate > 0) {
          const taxablePrice = Number((price / (1 + gstRate / 100)).toFixed(2));
          lineTotal = taxablePrice * quantity;
          finalAmount = Number((amount / (1 + gstRate / 100)).toFixed(2));
        }

        const discountVal = lineTotal - finalAmount;
        return sum + discountVal;
      }, 0);

    return totalDiscount;
  };
  const additionalDiscount = calculateAdditionalDiscount();
  const shouldShowAdditionalDiscount = additionalDiscount > 0 &&
    (!data?.coupon?.discountAmount || data.coupon.discountAmount === 0);

  return (
    <div className="standard-summary-section">
      <div className="standard-amount-summary">
        {!isWalletBill ? (
          <>
            {/* <div className="standard-summary-row">
              <span>Subtotal:</span>
              <span>
                ₹
                {data?.billType === 'Membership'
                  ? parseFloat(data?.memberships?.[0]?.price || 0).toFixed(2)
                  : data?.billType === 'Package'
                    ? parseFloat(data?.packages?.[0]?.price || 0).toFixed(2)
                    : parseFloat(data?.baseTotal || 0).toFixed(2)}
              </span>
            </div> */}
             <div className="standard-summary-row">
  <span>Subtotal (Taxable):</span>
  <span>₹{taxableSubTotal.toFixed(2)}</span>
</div>

            {shouldShowAdditionalDiscount && (
              <div className="standard-summary-row standard-discount-row">
                <span>Additional Discount:</span>
                <span style={{ color: '#d32f2f' }}>-₹{Math.round(additionalDiscount)}</span>
              </div>
            )}

          {data?.useMembership && data.services?.some((s) => Number(s.discount) === 100 && s.discountType === '%') && (
              <div className="standard-summary-row standard-discount-row">
                <span>Membership Discount:</span>
                <span style={{ color: '#d32f2f' }}>
                  -₹
                  {data.services
                  .filter((s) => Number(s.discount) === 100 && s.discountType === '%')
                    .reduce((sum, s) => sum + s.price * s.quantity, 0)}
                </span>
              </div>
            )}

          {data?.packageUniqueId?.length > 0 && data.services?.some((s) => Number(s.discount) === 100 && s.discountType === '%') && (
              <div className="standard-summary-row standard-discount-row">
                <span>Package Discount:</span>
                <span style={{ color: '#d32f2f' }}>
                  -₹
                  {data.services
                  .filter((s) => Number(s.discount) === 100 && s.discountType === '%')
                    .reduce((sum, s) => sum + s.price * s.quantity, 0)}
                </span>
              </div>
            )}

            {data?.coupon?.discountAmount > 0 && (
              <div className="standard-summary-row standard-discount-row">
                <span>Coupon Discount ({data.coupon.couponCode}):</span>
                <span style={{ color: '#d32f2f' }}>-₹{data.coupon.discountAmount}</span>
              </div>
            )}

            {data?.rewardPointRedeemAmount > 0 && (
              <div className="standard-summary-row standard-discount-row">
                <span>Reward Points:</span>
                <span style={{ color: '#d32f2f' }}>-₹{data.rewardPointRedeemAmount}</span>
              </div>
            )}

            <div className="standard-summary-row standard-net-amount-row">
              <span>Net Amount (After Discounts):</span>
              <span>
                ₹
                {data.rewardPointRedeemAmount > 0
                  ? data.subTotal - data.rewardPointRedeemAmount
                  : data.subTotal}
              </span>
            </div>

            {(data?.taxes?.taxType === 'Exclusive' || data?.taxes?.taxType === 'Ingst') &&
              (totalGstValue / 2) > 0 && (
                <>
                  <div className="standard-summary-row">
                    <span>SGST :</span>
                    <span>+₹{(totalGstValue / 2).toFixed(2)}</span>
                  </div>
                  <div className="standard-summary-row">
                    <span>CGST :</span>
                    <span>+₹{(totalGstValue / 2).toFixed(2)}</span>
                  </div>
                </>
              )}

            <div className="standard-summary-row standard-total-row">
              <span>Total Amount</span>
              <span>₹{data?.amountPayable}</span>
            </div>

            <div className="standard-summary-row">
              <span>Amount Received:</span>
              <span style={{ color: '#2e7d32', fontWeight: 'bold' }}>
                ₹{data?.amountPaid?.reduce((acc, p) => acc + Number(p.amount), 0)}
              </span>
            </div>

            {data.paidDues > 0 && (
              <div className="standard-summary-row standard-due-row">
                <span>Due Balance:</span>
                <span style={{ color: '#d32f2f', fontWeight: 'bold' }}>₹{data.paidDues}</span>
              </div>
            )}
          </>
        ) : (
          // Wallet Bill Summary
          <>
            {/* <div className="standard-summary-row">
              <span>Amount Credited in Wallet:</span>
              <span>₹{data?.amountAdded}</span>
            </div>
            <div className="standard-summary-row">
              <span>Subtotal:</span>
              <span>₹{data?.subTotal}</span>
            </div> */}
             <div className="standard-summary-row">
  <span>Subtotal:</span>
  <span>₹{data?.subTotal}</span>
</div>
            {(data?.taxes?.taxType === 'Exclusive' || data?.taxes?.taxType === 'Ingst') && (
              <>
                <div className="standard-summary-row">
                  <span>SGST :</span>
                    <span>+₹{(totalGstValue / 2).toFixed(2)}</span>
                </div>
                <div className="standard-summary-row">
                  <span>CGST :</span>
                    <span>+₹{(totalGstValue / 2).toFixed(2)}</span>
                </div>
              </>
            )}

            <div className="standard-summary-row standard-total-row">
              <span>Total Amount</span>
              <span>₹{data?.amountPayable}</span>
            </div>

            <div className="standard-summary-row">
              <span>Amount Received:</span>
              <span style={{ color: '#2e7d32', fontWeight: 'bold' }}>
                ₹{data?.amountPaid?.reduce((acc, p) => acc + Number(p.amount), 0)}
              </span>
            </div>
          </>
        )}

        {/* {data?.remainingWalletAmount && (
          <div className="standard-summary-row">
            <span>Remaining Wallet Balance:</span>
            <span style={{ color: '#2e7d32', fontWeight: 'bold' }}>
              ₹{data?.remainingWalletAmount}
            </span>
          </div>
        )} */}
         {(data?.remainingWalletAmount || 
            data?.amountPaid?.some((p) => p.paymentType === 'Wallet')) && (
            <div className="standard-summary-row">
              <span>Remaining Wallet Balance:</span>
              <span style={{ color: '#2e7d32', fontWeight: 'bold' }}>
                ₹{data?.remainingWalletAmount ?? data?.advancedGiven ?? 0}
              </span>
            </div>
          )}
      </div>
    </div>
  );
};

export default BillPdf;
